// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4g-5";
export var imageContainer = "_4g-4";
export var metricsGrid = "_4g-2";
export var productDetailContainer = "_4g-1";
export var productListContainer = "_4g-0";
export var subscriberTableContainer = "_4g-3";